import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";

@Injectable()
export class ObservableBackendService {

    constructor(private http:Http) {
    }

    public post(uri:string, data:any, headers:any):Observable<any> {
        return this.http.post(uri, data, headers).map(this.mapResult);
    }

    public get(uri:string, data:any):Observable<any> {
        var config:any = {};
        //config.headers = headers;
        if (data != null) {
            config.search = data;
        }
		
		console.log("URL:" + uri);
        return this.http.get(uri, config).map(this.mapResult);
    }

    public getAttachment(uri:string, data:any):Observable<any> {
        var config:any = {};
        if (data != null) {
            config.search = data;
        }
        return this.http.get(uri, config).map(this.mapResultAttachment);
    }

    public put(uri:string, data:any, headers:any):Observable<any> {
        return this.http.put(uri, data, headers).map(this.mapResult);
    }

    public delete(uri:string, data:any, headers:any):Observable<any> {
        return this.http.delete(uri, data).map(this.mapResult);
    }

    private mapResult(res:any):any {
        if (res.url != null && res.url.endsWith('index.html')) {//expiro la session
            location.href = '/login?sessionExpired';
        }
        return (res) ? res.json() : res;
    }

    private mapResultAttachment(res:any):any {
        if (res.url != null && res.url.endsWith('index.html')) {
            location.href = '/login?sessionExpired';
        }
        return res;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/observableBackend.service.ts
 **/